import { z } from 'zod'

export const pushToSmsSchema = z.object({
  masterTaskId: z.string(),
})
